/* RECKLESS v2 — interacciones de la PDP.
   El <select name="id"> sigue siendo la fuente de verdad de la variante:
   los botones sólo lo escriben y disparan change. */
(function () {
  'use strict';

  function initAll(scope) {
    var host = scope || document;
    var list = [];
    if (host.classList && host.classList.contains('rk2')) list.push(host);
    [].push.apply(list, [].slice.call(host.querySelectorAll('.rk2')));
    list.forEach(init);
  }

  function init(root) {
    if (!root) return;
    /* el editor de Shopify re-renderiza la sección al cambiar un ajuste.
       Sin esta marca, init() volvía a colgar listeners sobre nodos ya vivos
       (duplicados) o no corría del todo sobre los nodos nuevos. */
    if (root.dataset.rk2Init === '1') return;
    root.dataset.rk2Init = '1';

    /* ---------- galería: slides + miniaturas (desktop) / dots (mobile) ---------- */
    var slidesBox = root.querySelector('[data-rk2-slides]');
    var slides = [].slice.call(root.querySelectorAll('.rk2-slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.rk2-thumb'));
    var dots   = [].slice.call(root.querySelectorAll('.rk2-dot'));

    function isMobile() { return window.matchMedia('(max-width: 989px)').matches; }

    /* En desktop todos los slides están apilados en inset:0, así que el navegador
       los considera visibles y `loading=lazy` no los frena: se bajaban las 13
       fotos completas de entrada. Van con data-src y se hidratan por vecindad. */
    function hidratar(i) {
      for (var k = i - 1; k <= i + 1; k++) {
        if (k < 0 || k >= slides.length) continue;
        var im = slides[k].querySelector('img[data-src]');
        if (!im) continue;
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-src');
        im.removeAttribute('data-srcset');
      }
    }

    function show(i) {
      if (i < 0 || i >= slides.length) return;
      if (isMobile() && slidesBox) {
        userMoved = true;   /* un clic en miniatura también cuenta como interacción */
        var destino = slides[i].offsetLeft;
        try { slidesBox.scrollTo({ left: destino, behavior: 'smooth' }); }
        catch (e) { slidesBox.scrollLeft = destino; }
        /* si el scroll suave no llegó (hay navegadores que lo cancelan con
           scroll-snap), se salta directo: la miniatura nunca queda sin efecto */
        clearTimeout(show.t);
        show.t = setTimeout(function () {
          if (Math.abs(slidesBox.scrollLeft - destino) > 4) slidesBox.scrollLeft = destino;
        }, 700);
      } else {
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      }
      marcar(i);
    }

    /* Marca la miniatura y el punto activos, actualiza el contador y arrastra
       la tira si la miniatura quedó fuera de vista. Se llama tanto al pulsar
       una miniatura como al deslizar el carrusel con el dedo — antes esto
       último sólo cambiaba el resaltado y la tira se quedaba quieta. */
    function marcar(i) {
      hidratar(i);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var cur = root.querySelector('[data-rk2-cur]');
      if (cur) cur.textContent = String(i + 1);
      marcarFlechas(i);
      var t = thumbs[i];
      if (!t || !t.parentElement) return;
      var strip = t.parentElement;
      if (strip.scrollWidth <= strip.clientWidth + 4) return;
      /* Se CENTRA la miniatura activa en vez de sólo dejarla visible.
         Antes quedaba pegada al borde: la tira parecía congelada y no se
         entendía que hubiera más fotos hacia adelante. */
      var destino = t.offsetLeft - (strip.clientWidth / 2) + (t.offsetWidth / 2);
      var max = strip.scrollWidth - strip.clientWidth;
      destino = Math.max(0, Math.min(max, destino));
      if (Math.abs(destino - strip.scrollLeft) > 2) {
        strip.scrollTo({ left: destino, behavior: 'smooth' });
      }
    }

    /* Flechas del carrusel móvil. La de "siguiente" late suave hasta el
       primer gesto; en la última foto se esconde, y la de "anterior" sólo
       aparece desde la segunda. Van por show(), que ya trae el respaldo
       para cuando el scroll suave no llega. */
    var fPrev = root.querySelector('[data-rk2-prev]');
    var fNext = root.querySelector('[data-rk2-next]');
    var fIdx = 0;
    function marcarFlechas(i) {
      fIdx = i;
      if (fPrev) fPrev.hidden = i <= 0;
      if (fNext) fNext.hidden = i >= slides.length - 1;
      if (i > 0 && fNext) fNext.classList.remove('is-hint');
    }
    if (fPrev) fPrev.addEventListener('click', function () { show(fIdx - 1); });
    if (fNext) fNext.addEventListener('click', function () { fNext.classList.remove('is-hint'); show(fIdx + 1); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.getAttribute('data-slide'))); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(Number(d.getAttribute('data-slide'))); });
    });

    /* arrancar en la foto principal: las imágenes lazy hacen que Chrome
       reancle el scroll y el carrusel abría en una foto del medio.
       ⚠️ Si el usuario ya deslizó, NO se toca más: antes estos reajustes
       diferidos lo devolvían al inicio y el carrusel parecía trabado. */
    var userMoved = false;
    if (slidesBox && slides.length) {
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        slidesBox.addEventListener(ev, function () { userMoved = true; }, { passive: true });
      });
      var startAt = 0;
      for (var q = 0; q < slides.length; q++) {
        if (slides[q].classList.contains('is-on')) { startAt = q; break; }
      }
      var settle = function () {
        if (userMoved || !isMobile()) return;
        slidesBox.scrollLeft = slides[startAt].offsetLeft;
      };
      /* Chrome reancla el scroll horizontal cada vez que carga una imagen,
         y eso sigue pasando bastante después de cualquier timeout fijo.
         Se vigila hasta que TODAS estén cargadas (tope 5 s) y se suelta en
         cuanto el usuario toca el carrusel. */
      settle();
      var vigilar = setInterval(function () {
        if (userMoved) { clearInterval(vigilar); return; }
        settle();
      }, 120);
      var soltar = function () { clearInterval(vigilar); };
      setTimeout(soltar, 9000);
      window.addEventListener('load', settle);
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        slidesBox.addEventListener(ev, soltar, { passive: true, once: true });
      });
    }

    /* al deslizar con el dedo, seguir el punto activo */
    if (slidesBox) {
      var st;
      slidesBox.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (!isMobile()) return;
          var w = slides[0] ? slides[0].getBoundingClientRect().width : slidesBox.clientWidth;
          var i = Math.max(0, Math.min(slides.length - 1, Math.round(slidesBox.scrollLeft / w)));
          marcar(i);
        }, 90);
      }, { passive: true });
    }

    /* ---------- variantes ---------- */
    var select = root.querySelector('#rk2-variants');
    var groups = [].slice.call(root.querySelectorAll('[data-rk2-optgroup]'));

    function currentChoice() {
      return groups.map(function (g) {
        var on = g.querySelector('input[type="radio"]:checked');
        return on ? on.value : null;
      });
    }

    function money(el, val) { if (el) el.textContent = val; }

    function paint(opt) {
      if (!opt) return;
      var onSale = opt.getAttribute('data-onsale') === '1';
      var avail = opt.getAttribute('data-available') === '1';

      money(root.querySelector('[data-rk2-price]'), opt.getAttribute('data-price'));
      money(root.querySelector('[data-rk2-cuota]'), opt.getAttribute('data-cuota'));
      [].slice.call(root.querySelectorAll('[data-rk2-ctaprice]')).forEach(function (e) {
        e.textContent = opt.getAttribute('data-price');
      });
      [].slice.call(root.querySelectorAll('[data-rk2-ctawas]')).forEach(function (e) {
        e.style.display = onSale ? '' : 'none';
        e.textContent = opt.getAttribute('data-compare');
      });

      [].slice.call(root.querySelectorAll('[data-rk2-ctapct]')).forEach(function (e) {
        e.style.display = onSale ? '' : 'none';
        e.textContent = '−' + opt.getAttribute('data-pct') + '%';
      });

      var was = root.querySelector('[data-rk2-was]');
      var chip = root.querySelector('[data-rk2-chip]');
      if (was) { was.style.display = onSale ? '' : 'none'; was.textContent = opt.getAttribute('data-compare'); }
      if (chip) { chip.style.display = onSale ? '' : 'none'; chip.textContent = 'Ahorras ' + opt.getAttribute('data-saving'); }
      var pctEl = root.querySelector('[data-rk2-pct]');
      if (pctEl) { pctEl.style.display = onSale ? '' : 'none'; pctEl.textContent = '−' + opt.getAttribute('data-pct') + '%'; }
      /* la pildora de oferta se va con el resto del bloque de rebaja: sin
         precio tachado no hay oferta que anunciar */
      var ofr = root.querySelector('[data-rk2-oferta]');
      if (ofr) ofr.style.display = onSale ? '' : 'none';

      /* La foto sigue a la variante SÓLO cuando el usuario cambia de opción.
         En la carga inicial esto movía el carrusel a la imagen de la variante
         (en Stone Shadow, la 6ª) y la ficha abría en una foto de modelo. */
      var mid = primerRender ? null : opt.getAttribute('data-img-id');
      if (mid) {
        for (var si = 0; si < slides.length; si++) {
          if (slides[si].getAttribute('data-media-id') === mid) { show(si); break; }
        }
      }

      [].slice.call(root.querySelectorAll('.rk2-cta')).forEach(function (b) { b.disabled = !avail; });
      var label = root.querySelector('[data-rk2-ctalabel]');
      if (label && !avail) label.textContent = 'Agotado';
    }

    var primerRender = true;

    function sync() {
      if (!select) return;
      var choice = currentChoice();
      var opts = [].slice.call(select.options);
      var match = opts.filter(function (o) {
        var vals = (o.getAttribute('data-options') || '').split('||');
        return choice.every(function (c, i) { return c === null || vals[i] === c; });
      })[0];
      if (!match) return;
      if (select.value !== match.value) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      paint(match);

      /* marcar como no disponibles las combinaciones muertas */
      groups.forEach(function (g, gi) {
        [].slice.call(g.querySelectorAll('input[type="radio"]')).forEach(function (inp) {
          var test = choice.slice();
          test[gi] = inp.value;
          var ok = opts.some(function (o) {
            var vals = (o.getAttribute('data-options') || '').split('||');
            return test.every(function (c, i) { return c === null || vals[i] === c; })
              && o.getAttribute('data-available') === '1';
          });
          inp.disabled = !ok;
        });
      });
    }

    groups.forEach(function (g) {
      g.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.type !== 'radio') return;
        var idx = g.getAttribute('data-rk2-optgroup');
        var lbl = root.querySelector('[data-rk2-optlabel="' + idx + '"]');
        if (lbl) lbl.textContent = input.value;
        sync();
      });
    });
    sync();
    primerRender = false;

    /* ---------- FAQ ---------- */
    var faqs = [].slice.call(root.querySelectorAll('.rk2-faq'));
    function openFaq(item, on) {
      var panel = item.querySelector('.rk2-faq__panel');
      item.setAttribute('aria-expanded', String(on));
      if (!panel) return;
      panel.style.maxHeight = on ? (panel.scrollHeight + 20) + 'px' : '0px';
      panel.style.opacity = on ? '1' : '0';
    }
    faqs.forEach(function (item) {
      item.addEventListener('click', function () {
        var wasOpen = item.getAttribute('aria-expanded') === 'true';
        faqs.forEach(function (o) { openFaq(o, false); });
        if (!wasOpen) openFaq(item, true);
      });
      if (item.getAttribute('aria-expanded') === 'true') openFaq(item, true);
    });

    /* ---------- "Te puede gustar": agregar sin recargar ---------- */
    var toast;
    function say(msg) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'rk2-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      requestAnimationFrame(function () { toast.classList.add('is-on'); });
      clearTimeout(say._t);
      say._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
    }
    function bumpCart(count) {
      var sel = ['.cart-count', '[data-cart-count]', '.header__cart-count', '.cart-item-count'];
      sel.forEach(function (s) {
        [].slice.call(document.querySelectorAll(s)).forEach(function (e) { e.textContent = count; });
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    [].slice.call(root.querySelectorAll('[data-rk2-add]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = Number(btn.getAttribute('data-rk2-add'));
        var par = btn.getAttribute('data-rk2-par') === '1';
        var label = btn.querySelector('.rk2-quickadd__t');
        var original = label ? label.textContent : '';
        btn.setAttribute('data-state', 'loading');
        if (label) label.textContent = 'Agregando…';
        /* Bundle 2º par: el botón agrega el par completo (la tarjeta + el lente
           de la ficha), salvo que el de la ficha ya esté en el carrito. */
        var main = par ? document.getElementById('rk2-variants') : null;
        var mainId = main ? Number(main.value) : 0;
        var items = (par && mainId)
          ? fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var ya = c.items.some(function (it) { return it.variant_id === mainId; });
              return ya ? [{ id: id, quantity: 1 }] : [{ id: mainId, quantity: 1 }, { id: id, quantity: 1 }];
            })
          : Promise.resolve([{ id: id, quantity: 1 }]);
        items
          .then(function (list) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: list })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            btn.setAttribute('data-state', 'done');
            if (label) label.textContent = 'Agregado ✓';
            bumpCart(cart.item_count);
            say(par ? 'Par agregado al carrito' : 'Agregado al carrito');
            setTimeout(function () {
              btn.removeAttribute('data-state');
              if (label) label.textContent = original;
            }, 2200);
          })
          .catch(function () {
            btn.removeAttribute('data-state');
            if (label) label.textContent = original;
            say('No se pudo agregar');
          });
      });
    });

    /* ---------- recomendados en carrusel: flechas en desktop ---------- */
    [].slice.call(root.querySelectorAll('[data-rk2-rail]')).forEach(function (rail) {
      var sec = rail.closest('.rk2-sec') || root;
      function step(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' }); }
      var prev = sec.querySelector('[data-rk2-rail-prev]');
      var next = sec.querySelector('[data-rk2-rail-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });

    /* ---------- despacho: fecha estimada de entrega ----------
       Todo se calcula en el cliente porque el HTML se cachea: si lo resolviera
       Liquid, la fecha quedaría congelada desde la primera visita. */
    (function () {
      /* la línea corta bajo el precio usa el mismo calendario: si la sección
         larga no está en la plantilla, lee la configuración desde la corta */
      var eta  = root.querySelector('[data-rk2-eta]');
      var host = root.querySelector('[data-rk2-ship]') || eta;
      if (!host) return;

      var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                   'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

      function num(attr, def) {
        var n = parseInt(host.getAttribute(attr) || '', 10);
        return isNaN(n) ? def : n;
      }
      var cut    = num('data-cut', 13);
      var rmMin  = num('data-rm-min', 1);
      var rmMax  = num('data-rm-max', 1);
      var clMin  = num('data-cl-min', 1);
      var clMax  = num('data-cl-max', 3);
      var buffer  = num('data-buffer', 1);   /* holgura: promete un rango, no una fecha */
      var freeMin = num('data-free-min', 80000);
      var precio  = num('data-price', 0);

      function ahoraCL() {
        try {
          return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
        } catch (e) { return new Date(); }
      }

      /* Dos calendarios distintos, que antes eran uno solo:
         - despacho: los días en que el paquete se entrega a la courier
         - tránsito: los días hábiles que tarda en llegar (siempre lun-vie)
         Si la tienda no despacha los viernes, una compra del jueves después
         del corte sale el LUNES, no el viernes. */
      var diasDespacho = (host.getAttribute('data-dias') || '1,2,3,4,5')
        .split(',').map(function (x) { return parseInt(x, 10); })
        .filter(function (x) { return !isNaN(x); });
      if (!diasDespacho.length) diasDespacho = [1, 2, 3, 4, 5];

      /* feriados de Chile (mismo listado que usa Liquid en main-product): ni se despacha ni corre el tránsito */
      var FERIADOS = (host.getAttribute('data-feriados') ||
        '01-01,04-03,04-04,05-01,05-21,06-29,07-16,08-15,09-18,09-19,10-12,10-31,11-01,12-08,12-25').split(',');
      function feriado(d) {
        var mm = ('0' + (d.getMonth() + 1)).slice(-2), dd = ('0' + d.getDate()).slice(-2);
        return FERIADOS.indexOf(mm + '-' + dd) !== -1;
      }
      function habil(d) { var w = d.getDay(); return w >= 1 && w <= 5 && !feriado(d); }
      function esDespacho(d) { return diasDespacho.indexOf(d.getDay()) !== -1 && !feriado(d); }

      function proximoDespacho(desde) {
        var d = new Date(desde.getTime());
        for (var i = 0; i < 14; i++) {
          d.setDate(d.getDate() + 1);
          if (esDespacho(d)) return d;
        }
        return d;
      }

      /* suma n días hábiles a una fecha (n=0 devuelve el mismo día si es hábil) */
      function sumarHabiles(desde, n) {
        var d = new Date(desde.getTime());
        var restan = n;
        while (restan > 0) {
          d.setDate(d.getDate() + 1);
          if (habil(d)) restan--;
        }
        return d;
      }

      /* "martes 8 de septiembre" — sin año, como MercadoLibre */
      function fecha(d) {
        return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()];
      }
      function fechaCorta(d) {
        return DIAS[d.getDay()] + ' ' + d.getDate();
      }
      /* "entre el viernes 4 y el lunes 7 de septiembre"; si el rango cruza de mes,
         el primero también lleva el suyo para que no se lea como una sola fecha */
      function entre(a, b) {
        if (a.getTime() === b.getTime()) return 'el ' + fecha(a);
        var ini = a.getMonth() === b.getMonth() ? fechaCorta(a) : fecha(a);
        return 'entre el ' + ini + ' y el ' + fecha(b);
      }

      var now = ahoraCL();
      var aTiempo = esDespacho(now) && now.getHours() < cut;

      /* día en que sale el paquete */
      var salida = aTiempo ? new Date(now.getTime()) : proximoDespacho(now);
      salida = new Date(salida.getFullYear(), salida.getMonth(), salida.getDate());

      var rmDesde = sumarHabiles(salida, rmMin);
      var rmHasta = sumarHabiles(salida, rmMax + buffer);
      var clDesde = sumarHabiles(salida, clMin);
      var clHasta = sumarHabiles(salida, clMax + buffer);

      /* ---- titular ---- */
      var gratis = precio >= freeMin;
      var lead = host.querySelector('[data-rk2-ship-lead]');
      var when = host.querySelector('[data-rk2-ship-when]');
      if (lead) lead.textContent = gratis ? 'Llega gratis' : 'Llega';
      if (when) when.textContent = ' ' + entre(rmDesde, rmHasta);
      host.classList.toggle('is-free', gratis);

      /* ---- línea corta bajo el precio ----
         Una sola fecha en palabras simples: "mañana" o "el martes 30", y el
         rango sólo si hay holgura. Regiones va abajo, en gris. */
      if (eta) {
        var hoy0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        function dia(d) {
          var dd = Math.round((d - hoy0) / 86400000);
          if (dd === 0) return 'hoy';
          if (dd === 1) return 'mañana';
          /* si no es este mes, se nombra el mes: "el martes 6" solo se lee como octubre si lo dice */
          return 'el ' + (d.getMonth() === now.getMonth() ? fechaCorta(d) : fecha(d));
        }
        function corto(a, b) {
          if (a.getTime() === b.getTime()) return dia(a);
          return 'entre ' + dia(a) + ' y ' + dia(b);
        }
        var eLead = eta.querySelector('[data-rk2-eta-lead]');
        var eWhen = eta.querySelector('[data-rk2-eta-when]');
        var eSub  = eta.querySelector('[data-rk2-eta-sub]');
        if (eLead) eLead.textContent = gratis ? 'Llega gratis' : 'Llega';
        if (eWhen) eWhen.textContent = corto(rmDesde, rmHasta);
        var faltaCorte = (cut - now.getHours()) * 60 - now.getMinutes();
        var regiones = 'Regiones: ' + (clMin === clMax ? clMin : clMin + ' a ' + clMax) + ' días hábiles';
        var tsub;
        if (aTiempo) {
          tsub = faltaCorte <= 180
            ? 'Compra en ' + (faltaCorte >= 60 ? Math.floor(faltaCorte / 60) + ' h ' : '') + (faltaCorte % 60) + ' min y puede salir hoy · ' + regiones
            : 'Comprando antes de las ' + cut + ':00 puede salir hoy · ' + regiones;
        } else {
          tsub = regiones;
        }
        if (eSub) eSub.textContent = tsub;
        eta.classList.toggle('is-free', gratis);
      }

      /* ---- línea de tiempo ---- */
      var titulo = host.querySelector('[data-rk2-ship-title]');
      var sub    = host.querySelector('[data-rk2-ship-sub]');
      var dot    = host.querySelector('[data-rk2-ship-dot]');
      var elRm   = host.querySelector('[data-rk2-ship-rm]');
      var elCl   = host.querySelector('[data-rk2-ship-cl]');

      var t, sTxt;
      if (aTiempo) {
        t = 'Puede salir hoy';
        sTxt = 'Muchos pedidos antes de las ' + cut + ':00 hrs salen el mismo día';
      } else if (Math.round((salida - new Date(now.getFullYear(), now.getMonth(), now.getDate()))
                  / 86400000) === 1) {
        t = 'Puede salir mañana';
        sTxt = 'El horario de despacho de hoy ya cerró';
      } else {
        t = 'Puede salir el ' + DIAS[salida.getDay()];
        if (esDespacho(now)) {
          sTxt = 'El horario de despacho de hoy ya cerró';
        } else if (now.getDay() === 0 || now.getDay() === 6) {
          sTxt = 'No despachamos sábados ni domingos';
        } else {
          sTxt = 'El próximo despacho sale el ' + DIAS[salida.getDay()];
        }
      }
      if (titulo) titulo.textContent = t;
      if (sub) sub.textContent = sTxt;
      if (dot) dot.classList.toggle('rk2-ship__dot--on', aTiempo);

      /* en la línea de tiempo va la forma corta: el titular ya dijo "Llega entre ..." */
      function rango(a, b) {
        var t;
        if (a.getTime() === b.getTime()) t = fecha(a);
        else t = (a.getMonth() === b.getMonth() ? fechaCorta(a) : fecha(a)) + ' a ' + fecha(b);
        return t.charAt(0).toUpperCase() + t.slice(1);
      }
      if (elRm) elRm.textContent = rango(rmDesde, rmHasta);
      if (elCl) elCl.textContent = rango(clDesde, clHasta);

      /* ---- nota de envío gratis ---- */
      var nota = host.querySelector('[data-rk2-ship-freenote]');
      if (nota && gratis) {
        nota.textContent = 'Este producto ya califica para envío gratis. Despachamos sólo dentro de Chile.';
      }

      /* ---- cuenta regresiva hasta el corte ---- */
      var caja  = host.querySelector('[data-rk2-ship-timer]');
      var reloj = host.querySelector('[data-rk2-ship-count]');
      var barra = host.querySelector('[data-rk2-ship-bar]');
      if (aTiempo && esDespacho(now) && caja && reloj) {
        var VENTANA = 4 * 3600;   /* las últimas 4 h antes del corte llenan la barra */
        caja.hidden = false;
        var tick = function () {
          var n = ahoraCL();
          var falta = (cut - n.getHours()) * 3600 - n.getMinutes() * 60 - n.getSeconds();
          if (falta <= 0) {
            caja.hidden = true;
            if (root.__rk2ship) { clearInterval(root.__rk2ship); root.__rk2ship = null; }
            return;
          }
          var h = Math.floor(falta / 3600);
          var m = Math.floor((falta % 3600) / 60);
          var sg = falta % 60;
          reloj.textContent = h > 0
            ? h + ' h ' + (m < 10 ? '0' : '') + m + ' min'
            : m + ' min ' + (sg < 10 ? '0' : '') + sg + ' s';
          if (barra) barra.style.width = Math.min(100, (falta / VENTANA) * 100) + '%';
          caja.classList.toggle('is-urgente', falta < 3600);
        };
        tick();
        if (root.__rk2ship) clearInterval(root.__rk2ship);
        root.__rk2ship = setInterval(tick, 1000);
      }

      /* el resto de la página nombra el día real de despacho, nunca "hoy" fuera de hora */
      var envio = aTiempo ? 'Puede salir hoy' : 'Puede salir el ' + DIAS[salida.getDay()];
      [].slice.call(document.querySelectorAll('[data-rk2-hoy]')).forEach(function (e) {
        var pre = e.getAttribute('data-rk2-hoy-pre');
        if (pre === null) pre = '';
        e.textContent = pre + (pre ? envio.charAt(0).toLowerCase() + envio.slice(1) : envio);
      });
    })();

    /* la segunda foto se adelanta en tiempo muerto: el primer clic no espera */
    (function () {
      var arranca = function () { hidratar(1); };
      if ('requestIdleCallback' in window) requestIdleCallback(arranca, { timeout: 3000 });
      else setTimeout(arranca, 1500);
    })();


    /* ---------- visor a pantalla completa ----------
       La foto grande (2048 px) sólo se pide al abrir: la carga inicial no
       paga nada por esto. El doble toque acerca al doble y se arrastra;
       en lentes, el detalle que justifica el precio está en la bisagra y
       el grabado de la varilla, no en el packshot completo. */
    var lb = root.querySelector('[data-rk2-lb]');
    if (lb && slides.length) {
      var lbImg   = lb.querySelector('[data-rk2-lb-img]');
      var lbCur   = lb.querySelector('[data-rk2-lb-cur]');
      var lbTot   = lb.querySelector('[data-rk2-lb-tot]');
      var lbHint  = lb.querySelector('[data-rk2-lb-hint]');
      var lbStage = lb.querySelector('[data-rk2-lb-stage]');
      var lbI = 0, lbZoom = false, lbAbierto = false, devolverFoco = null;

      if (lbTot) lbTot.textContent = String(slides.length);

      function fuente(i) {
        var im = slides[i] && slides[i].querySelector('img');
        if (!im) return null;
        return im.getAttribute('data-full') || im.getAttribute('data-src') || im.currentSrc || im.src;
      }

      function resetZoom() {
        lbZoom = false;
        lbImg.style.transform = '';
        lbImg.classList.remove('is-zoom');
        if (lbHint) lbHint.textContent = 'Toca la foto para acercar';
      }

      function pintar(i) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        lbI = i;
        var src = fuente(i);
        if (src) lbImg.src = src;
        var alt = slides[i].querySelector('img');
        lbImg.alt = alt ? alt.alt : '';
        if (lbCur) lbCur.textContent = String(i + 1);
        resetZoom();
        /* adelanta la vecina para que el siguiente paso no espere */
        var sig = fuente(i + 1 >= slides.length ? 0 : i + 1);
        if (sig) { var pre = new Image(); pre.src = sig; }
      }

      function abrir(i) {
        devolverFoco = document.activeElement;
        pintar(i);
        lb.hidden = false;
        lbAbierto = true;
        document.documentElement.classList.add('rk2-lb-open');
        requestAnimationFrame(function () { lb.classList.add('is-on'); });
        var x = lb.querySelector('[data-rk2-lb-x]');
        if (x) x.focus();
      }

      function cerrar() {
        lb.classList.remove('is-on');
        lbAbierto = false;
        document.documentElement.classList.remove('rk2-lb-open');
        setTimeout(function () { if (!lbAbierto) { lb.hidden = true; lbImg.removeAttribute('src'); } }, 220);
        /* la galería queda donde la dejó el visor */
        show(lbI);
        if (devolverFoco && devolverFoco.focus) devolverFoco.focus();
      }

      function paso(d) { pintar(lbI + d); }

      /* --- disparadores --- */
      var lupa = root.querySelector('[data-rk2-expand]');
      if (lupa) lupa.addEventListener('click', function (e) { e.stopPropagation(); abrir(indiceActual()); });
      slides.forEach(function (sl, k) {
        sl.addEventListener('click', function () { if (!lbAbierto) abrir(k); });
      });

      function indiceActual() {
        for (var q = 0; q < slides.length; q++) {
          if (slides[q].classList.contains('is-on')) return q;
        }
        if (slidesBox) {
          var w = slides[0].getBoundingClientRect().width || slidesBox.clientWidth;
          return Math.max(0, Math.min(slides.length - 1, Math.round(slidesBox.scrollLeft / w)));
        }
        return 0;
      }

      var bx = lb.querySelector('[data-rk2-lb-x]');
      var bg = lb.querySelector('[data-rk2-lb-bg]');
      var bp = lb.querySelector('[data-rk2-lb-prev]');
      var bn = lb.querySelector('[data-rk2-lb-next]');
      if (bx) bx.addEventListener('click', cerrar);
      if (bg) bg.addEventListener('click', cerrar);
      if (bp) bp.addEventListener('click', function (e) { e.stopPropagation(); paso(-1); });
      if (bn) bn.addEventListener('click', function (e) { e.stopPropagation(); paso(1); });

      document.addEventListener('keydown', function (e) {
        if (!lbAbierto) return;
        if (e.key === 'Escape') { e.preventDefault(); cerrar(); }
        else if (e.key === 'ArrowRight') paso(1);
        else if (e.key === 'ArrowLeft') paso(-1);
        else if (e.key === 'Tab') {
          /* el foco no se escapa del visor mientras está abierto */
          var foco = lb.querySelectorAll('button');
          if (!foco.length) return;
          var pri = foco[0], ult = foco[foco.length - 1];
          if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
          else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
        }
      });

      /* --- acercar: un toque en la foto alterna 1x / 2,4x --- */
      function acercar(e) {
        var r = lbImg.getBoundingClientRect();
        if (lbZoom) { resetZoom(); return; }
        var px = ((e.clientX - r.left) / r.width) * 100;
        var py = ((e.clientY - r.top) / r.height) * 100;
        lbZoom = true;
        lbImg.classList.add('is-zoom');
        lbImg.style.transformOrigin = px + '% ' + py + '%';
        lbImg.style.transform = 'scale(2.4)';
        if (lbHint) lbHint.textContent = 'Arrastra para mover · toca para alejar';
      }
      lbImg.addEventListener('click', function (e) { e.stopPropagation(); acercar(e); });

      /* arrastrar la foto acercada */
      var arr = false, ax = 0, ay = 0, ox = 50, oy = 50;
      lbImg.addEventListener('pointerdown', function (e) {
        if (!lbZoom) return;
        arr = true; ax = e.clientX; ay = e.clientY;
        var o = (lbImg.style.transformOrigin || '50% 50%').split(' ');
        ox = parseFloat(o[0]) || 50; oy = parseFloat(o[1]) || 50;
        lbImg.setPointerCapture(e.pointerId);
      });
      lbImg.addEventListener('pointermove', function (e) {
        if (!arr) return;
        var r = lbImg.getBoundingClientRect();
        ox = Math.max(0, Math.min(100, ox - ((e.clientX - ax) / r.width) * 100));
        oy = Math.max(0, Math.min(100, oy - ((e.clientY - ay) / r.height) * 100));
        ax = e.clientX; ay = e.clientY;
        lbImg.style.transformOrigin = ox + '% ' + oy + '%';
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        lbImg.addEventListener(ev, function () { arr = false; });
      });

      /* deslizar entre fotos cuando NO está acercada */
      var sx = 0, sy = 0, sw = false;
      lbStage.addEventListener('touchstart', function (e) {
        if (lbZoom || e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; sw = true;
      }, { passive: true });
      lbStage.addEventListener('touchend', function (e) {
        if (!sw) return;
        sw = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) paso(dx < 0 ? 1 : -1);
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) cerrar();
      }, { passive: true });
    }

    /* ---------- la barra fija sigue al precio del boton principal ----------
       Kaching Bundles reescribe el precio directamente dentro del <span> del
       boton principal (no pasa por el <select> de variante, asi que paint() ni
       se entera). La barra fija tiene su propio nodo y se quedaba con el precio
       de una unidad: el cliente elegia el pack de 2 y abajo seguia viendo el
       precio de 1. Se refleja el nodo de arriba en el de abajo, y el tachado
       pasa a ser el precio de lista del pack, que la propia barra publica.
       Si el pack no expone precio de lista, el tachado se esconde: mejor sin
       ancla que con un ancla que no corresponde a lo que se esta comprando. */
    (function () {
      var form     = root.querySelector('#rk2-form');
      var sticky   = root.querySelector('[data-rk2-sticky]');
      if (!form || !sticky) return;
      var principal = form.querySelector('[data-rk2-ctaprice]');
      var precios   = [].slice.call(sticky.querySelectorAll('[data-rk2-ctaprice]'));
      var tachados  = [].slice.call(sticky.querySelectorAll('[data-rk2-ctawas]'));
      if (!principal || !precios.length) return;

      var espejo = function () {
        var txt = (principal.textContent || '').trim();
        if (txt) {
          precios.forEach(function (e) {
            if ((e.textContent || '').trim() !== txt) e.textContent = txt;
          });
        }
        if (!tachados.length) return;
        var barra = document.querySelector('.kaching-bundles__bar--selected');
        if (!barra) return;                 /* sin bundles, manda paint() */
        var lista = barra.querySelector('.kaching-bundles__bar-full-price');
        var vlista = lista ? (lista.textContent || '').trim() : '';
        tachados.forEach(function (e) {
          if (vlista) { e.textContent = vlista; e.style.display = ''; }
          else { e.style.display = 'none'; }
        });
      };

      var mo = new MutationObserver(espejo);
      mo.observe(principal, { childList: true, characterData: true, subtree: true });
      root.__rk2mirror = mo;

      /* la app monta sus barras despues del primer render y marca la elegida
         cambiando clases, no el texto del boton: hay que vigilar las dos cosas */
      var arranca = function () {
        var cajaK = document.querySelector('[class*="kaching-bundles"]');
        if (!cajaK) return false;
        var mo2 = new MutationObserver(espejo);
        mo2.observe(cajaK, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
        root.__rk2mirrorK = mo2;
        espejo();
        return true;
      };
      if (!arranca()) {
        var intentos = 0;
        var t = setInterval(function () {
          if (arranca() || ++intentos > 20) clearInterval(t);
        }, 500);
      }
      espejo();
    })();

    /* ---------- "ver resenas" tiene que caer en las resenas ----------
       El ancla #rk2-resenas vive en la seccion rk-reviews del tema, que ya no
       esta en la plantilla de producto: ahi las resenas las pinta el widget de
       Loox (#looxReviews). Los dos enlaces apuntaban a un id inexistente y el
       clic no hacia nada. El destino se resuelve al hacer clic, no al pintar,
       asi que sirve tanto si vuelve la seccion del tema como si sigue la app.
       El desplazamiento descuenta el alto de la cabecera fija, que si no el
       titulo queda escondido debajo. */
    (function () {
      var enlaces = [].slice.call(root.querySelectorAll('a[href="#rk2-resenas"]'));
      if (!enlaces.length) return;

      var destino = function () {
        return document.getElementById('rk2-resenas')
            || document.getElementById('looxReviews')
            || document.querySelector('.rk2-revhead')
            || document.querySelector('[id*="loox" i], [class*="loox-reviews" i]');
      };
      var alturaFija = function () {
        var alto = 0;
        [].slice.call(document.querySelectorAll('header, .rk-trust-strip, [class*="header"]')).forEach(function (e) {
          var cs = getComputedStyle(e);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
          var r = e.getBoundingClientRect();
          if (r.top <= 2 && r.height > alto && r.height < 200) alto = r.height;
        });
        return alto;
      };

      enlaces.forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var t = destino();
          if (!t) return;                    /* sin destino, que haga lo de siempre */
          ev.preventDefault();
          /* al hacer clic desde arriba la cabecera todavia no esta pegada y mide 0,
             pero al llegar si lo estara: se reserva su alto igual. */
          var y = t.getBoundingClientRect().top + window.pageYOffset - Math.max(alturaFija(), 64) - 12;
          var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, y), behavior: suave ? 'smooth' : 'auto' });
        });
      });
    })();

    /* ---------- carrusel corto de resenas bajo el boton ----------
       Un rail con scroll-snap: el dedo ya sabe arrastrarlo y sin JS sigue
       siendo deslizable. Las flechas y los puntos son encima de eso, no
       en vez de eso. El indice se lee del scroll, no de un contador propio,
       asi el arrastre a mano y los botones nunca se desincronizan. */
    (function () {
      var caja = root.querySelector('[data-rk2-minirev]');
      if (!caja) return;
      var rail = caja.querySelector('[data-rk2-mrail]');
      if (!rail) return;
      var cards = [].slice.call(rail.children);
      var dots  = [].slice.call(caja.querySelectorAll('.rk2-minirev__dot'));
      var prev  = caja.querySelector('[data-rk2-mprev]');
      var next  = caja.querySelector('[data-rk2-mnext]');
      if (cards.length < 2) return;

      var indice = function () {
        var paso = rail.scrollWidth / cards.length;
        return Math.max(0, Math.min(cards.length - 1, Math.round(rail.scrollLeft / paso)));
      };
      var ir = function (i) {
        var paso = rail.scrollWidth / cards.length;
        rail.scrollLeft = Math.max(0, Math.min(cards.length - 1, i)) * paso;
      };
      var pintar = function () {
        var i = indice();
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= cards.length - 1;
      };

      if (prev) prev.addEventListener('click', function () { ir(indice() - 1); });
      if (next) next.addEventListener('click', function () { ir(indice() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { ir(parseInt(d.getAttribute('data-i'), 10) || 0); });
      });

      var t = null;
      rail.addEventListener('scroll', function () {
        if (t) return;
        t = setTimeout(function () { t = null; pintar(); }, 80);
      }, { passive: true });
      pintar();
    })();

    /* ---------- prueba social: las caras van rotando ----------
       El pool son resenas verificadas reales de Loox de este producto, ya
       serializadas por Liquid. Se cambia UNA cara por tick, nunca las tres a
       la vez: el movimiento tiene que leerse como "sigue entrando gente", no
       como un carrusel. Si hay menos gente que caras visibles, no rota. */
    (function () {
      var soc = root.querySelector('[data-rk2-social]');
      if (!soc) return;
      var cajaJson = soc.querySelector('[data-rk2-social-pool]');
      var caras = [].slice.call(soc.querySelectorAll('[data-rk2-face]'));
      var nomb  = soc.querySelector('[data-rk2-social-names]');
      var ms = parseInt(soc.getAttribute('data-rk2-social-ms'), 10);
      if (!cajaJson || !caras.length || !ms) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var pool;
      try { pool = JSON.parse(cajaJson.textContent || '[]'); } catch (e) { return; }
      if (!pool || pool.length <= caras.length) return;
      /* Liquid manda primero a quienes subieron foto. Si hay mas caras reales
         que huecos, se rota solo entre ellas: el monograma es el respaldo para
         productos con pocas fotos, no el estado normal de la tira. */
      var conFoto = pool.filter(function (x) { return x && x.f; });
      if (conFoto.length > caras.length) pool = conFoto;

      /* las primeras N del pool ya estan pintadas en el HTML */
      var vivos = pool.slice(0, caras.length);
      var sig = caras.length;
      var slot = 0;

      var pinta = function (cara, dato) {
        var img = cara.querySelector('img');
        if (dato.f) {
          if (img) { img.src = 'https:' + dato.f; img.alt = ''; }
          else cara.innerHTML = '<img src="https:' + dato.f + '" alt="" width="72" height="72">';
        } else {
          cara.innerHTML = '<em>' + (dato.n || '?').trim().charAt(0).toUpperCase() + '</em>';
        }
      };

      var tick = function () {
        if (document.hidden) return;
        var dato = pool[sig % pool.length];
        sig++;
        /* no repetir a alguien que ya esta en pantalla */
        var vueltas = 0;
        while (vueltas < pool.length && vivos.some(function (v) { return v.n === dato.n; })) {
          dato = pool[sig % pool.length]; sig++; vueltas++;
        }
        var cara = caras[slot];
        vivos[slot] = dato;
        slot = (slot + 1) % caras.length;

        cara.classList.add('is-out');
        setTimeout(function () {
          pinta(cara, dato);
          cara.classList.remove('is-out');
          if (nomb) nomb.textContent = vivos.map(function (v) { return v.n; }).join(', ');
        }, 340);
      };

      if (root.__rk2soc) clearInterval(root.__rk2soc);
      root.__rk2soc = setInterval(tick, Math.max(1800, ms));
    })();

    /* ---------- barra fija mobile ---------- */
    var sticky = root.querySelector('[data-rk2-sticky]');
    var mainCta = root.querySelector('[data-rk2-cta]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -100% 0px' });
      io.observe(mainCta);
      root.__rk2io = io;
    }
  }

  function boot() { initAll(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Editor de temas: al recargar una sección hay que re-inicializar sobre el
     DOM nuevo, y al descargarla soltar el observer para no dejar basura. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el) initAll(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target;
    var r = el && el.querySelector ? el.querySelector('.rk2') : null;
    if (r && r.__rk2io) { r.__rk2io.disconnect(); r.__rk2io = null; }
    if (r && r.__rk2soc) { clearInterval(r.__rk2soc); r.__rk2soc = null; }
    if (r && r.__rk2mirror) { r.__rk2mirror.disconnect(); r.__rk2mirror = null; }
    if (r && r.__rk2mirrorK) { r.__rk2mirrorK.disconnect(); r.__rk2mirrorK = null; }
  });
})();
